<template>
  <RiskCalculationWithTable
    :major-risk-num="0"
    :minor-risk-num="1"
    :ofi-risk-num="2"
    :un-answer-num="0"
    :result-list="items"
  />
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          leadingIcon: "icon-alert-criminal",
          text: "刑事責任",
          majorNum: 0,
          minorNum: 2,
          ofiNum: 1,
        },
        {
          leadingIcon: "icon-alert-shutdown",
          text: "停廠停業",
          majorNum: 1,
          minorNum: 2,
          ofiNum: 1,
        },
        {
          leadingIcon: "icon-alert-fine",
          text: "罰        鍰",
          majorNum: 2,
          minorNum: 2,
          ofiNum: 1,
        },
      ],
    }
  }
}
</script>